module.exports = __webpack_public_path__ + "img/login_logo@2x.da957cdb.png";